import {inject, Injectable} from '@angular/core';
import {AuthenticationService} from '@modules/authentication';
import {AnyLinkType} from 'shared/pretty-easy-navigation/models';
import {PrettyEasyNavigationService} from 'shared/pretty-easy-navigation/pretty-easy-navigation.service';
import {TrainerMenu, LearnerMenu, GuestMenu, ParentMenu} from './models';

@Injectable({
  providedIn: 'root'
})
export class PrettyEasyMenuInitializerService {
    menus = {
        trainer: TrainerMenu,
        learner: LearnerMenu,
        guest: GuestMenu,
        parent: ParentMenu,
    } as const;

    private prettyEasyNavigationService = inject(PrettyEasyNavigationService);
    private authService = inject(AuthenticationService);

    public initializeMenu(): void {
        this.prettyEasyNavigationService.setMenu(this.menus.guest)
    }

    public setMenu(menuName: keyof typeof this.menus): void {
        const menu = this.menus[menuName];
        if (menu) {
            this.editMenuIfNeeded(menu);

            this.prettyEasyNavigationService.setMenu(menu);
        } else {
            console.warn(`Menu with name ${menuName} not found.`);
        }

    }

    private editMenuIfNeeded(menu: AnyLinkType[]): void {
        const flattenedMenu = this.flattenMenu(menu);
        flattenedMenu.forEach(item => {
            if (item.type === 'link') {
                switch (item.link) {
                    case '{{USER_CORPUS_LINK}}':
                        item.link = `/corpus/user/${(this.authService.userData?.id)}`;
                        break;
                }
            }
        })
    }

    private flattenMenu(menu: AnyLinkType[]): AnyLinkType[] {
        return menu.reduce((acc: AnyLinkType[], item) => {
            acc.push(item);
            if (item.type === 'linkGroup'
            || item.type === 'accordionLinkGroup')
                acc.push(...this.flattenMenu(item.links));
            return acc;
        }, []);

    }

    public add(item: AnyLinkType): void {
        const menu = this.prettyEasyNavigationService.menu()
        menu.push(item);
        this.prettyEasyNavigationService.setMenu(menu);
    }
}
